module.exports = __webpack_public_path__ + "img/1.ede71a15.png";